"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importStar(require("react"));
var Text_1 = __importDefault(require("../../Text"));
var style_1 = require("../../../style");
var constant_1 = require("../../../constant");
var Gray = style_1.DesignSystemThemeColor.Gray;
var mainContainer = react_1.css({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    padding: '0px',
    cursor: 'pointer',
});
var childContainer = react_1.css({
    position: 'relative',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: '2px 0px 0px',
});
var textContainer = react_1.css({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    padding: '0px',
});
var defaultThemeLabelStyleConfig = {
    css: react_1.css({
        userSelect: 'none',
        fontSize: style_1.pxToRem(16),
        color: style_1.SixsenseColor.Gray.DARK_2,
    }),
};
var designSystemLabelStyleConfig = {
    color: Gray.DARK_4,
    size: '14px',
    weight: 500,
    lineHeight: '150%',
};
var designSystemSublabelStyleConfig = {
    color: Gray.LIGHT_1,
    size: '14px',
    weight: 400,
    lineHeight: '150%',
};
var ControlLabel = function (_a) {
    var children = _a.children, _b = _a.labelPosition, labelPosition = _b === void 0 ? 'after' : _b, subLabel = _a.subLabel, label = _a.label, rest = __rest(_a, ["children", "labelPosition", "subLabel", "label"]);
    var theme = react_1.useTheme();
    var isTheme6DS = theme.name === constant_1.DESIGN_SYSTEM;
    var labelStyle = react_2.useMemo(function () { return isTheme6DS ? designSystemLabelStyleConfig : defaultThemeLabelStyleConfig; }, [isTheme6DS]);
    var subLabelStyle = react_2.useMemo(function () { return isTheme6DS ? designSystemSublabelStyleConfig : defaultThemeLabelStyleConfig; }, [isTheme6DS]);
    return label || subLabel ? (react_1.jsx("label", __assign({ css: mainContainer }, rest),
        labelPosition === 'after' && react_1.jsx("div", { css: childContainer }, children),
        react_1.jsx("div", { css: textContainer },
            react_1.jsx(Text_1.default, __assign({}, labelStyle),
                " ",
                label,
                " "),
            subLabel ? react_1.jsx(Text_1.default, __assign({}, subLabelStyle),
                " ",
                subLabel,
                " ") : null),
        labelPosition === 'before' && react_1.jsx("div", { css: childContainer }, children))) : (react_1.jsx(react_2.default.Fragment, null, children));
};
exports.default = ControlLabel;
